import { render, staticRenderFns } from "./Kajabi.vue?vue&type=template&id=60894020&"
import script from "./Kajabi.vue?vue&type=script&lang=js&"
export * from "./Kajabi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports